import * as React from 'react'

import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardMedia from '@mui/material/CardMedia'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'

// import Button from "@mui/material/Button";
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import K from '../../services/k'
import Chip from '@mui/material/Chip'
import './productcard.css'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'

import { useHistory } from 'react-router-dom'
import { useState } from 'react'
import Axios from 'axios'
import swal from 'sweetalert'
import { Button } from 'react-bootstrap'

const ProductCard = ({ mealObj, restaurant, props }) => {
  const [open, setOpen] = React.useState(false)
  const [scroll, setScroll] = React.useState('paper')

  const [currentClickedMeal, setcurrentClickedMeal] = React.useState({})

  const handleClickOpen = (scrollType, mealdata) => () => {
    handleProductCardClicked()
    setcurrentClickedMeal(mealdata)
    setOpen(true)
    setScroll(scrollType)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const descriptionElementRef = React.useRef(null)
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef
      if (descriptionElement !== null) {
        descriptionElement.focus()
      }
    }
  }, [open])

  let arrayOfWeekdays = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ]
  //reload cart
  const token = localStorage.getItem(['__react_session__'])
  const jsontoken = JSON.parse(token)

  //Cart details
  const [qty, setqty] = useState(1)
  const [sizename, setsizename] = useState('')
  const [sizeprice, setsizeprice] = useState(0)

  if (
    jsontoken !== null &&
    jsontoken.api_token &&
    jsontoken.api_token !== null &&
    jsontoken.api_token !== ''
  ) {
    var loggedin = true
  } else {
    var loggedin = false
  }
  const history = useHistory()

  const [sizes, setsizes] = useState([])

  const [currentmealid, setcurrentmealid] = useState(0)
  const alertlogin = () => {
    if (!loggedin) {
      swal({
        title: 'Alert!',
        text: 'Please login!',
        icon: 'warning',
      })
      history.push('/login')
    }
  }

  //assign flavours to states
  const [stateflavours, setstateflavours] = useState([])

  const totalcalculate = (meal_flavours = null) => {
    var size_price = sizeprice
    var option_price = 0

    var flavours = meal_flavours !== null ? meal_flavours : stateflavours
    flavours.map((flavour, index) => {
      var flavour_items = flavour.flavouritems
      flavour_items.map((flavour_item, item_index) => {
        if (flavour_item.selected === 1) {
          var add_price = parseInt(flavour_item.add_price)
          if (add_price > 0) {
            option_price = option_price + add_price
          }
        }
      })
    })
    settotals(qty * (parseInt(size_price) + option_price))
  }

  const quantitychange = (e) => {
    setqty(e.target.value)
  }
  const sizechange = (e) => {
    var index = e.nativeEvent.target.selectedIndex
    setsizename(e.nativeEvent.target[index].text)
    setsizeprice(e.target.value)
  }

  //total states
  const [totals, settotals] = useState(sizeprice)

  const addqty = () => {
    setqty(qty + 1)
  }
  const subqty = () => {
    if (qty > 1) {
      setqty(qty - 1)
    }
  }

  const [flavourname, setflavourname] = useState('No Option')
  //size price
  const [flavourid, setflavourid] = useState(0)
  const flavourchange = (e) => {
    let flavourindex = e.target.value
    let flavourid, flavourname
    try {
      flavourid =
        flavourindex === 0 || flavourindex === ''
          ? 0
          : stateflavours[flavourindex - 1].id
      flavourname =
        flavourindex === 0 || flavourindex === ''
          ? 'No Option'
          : stateflavours[flavourindex - 1].flavour
    } catch (error) {
      flavourid = 0
      flavourname = 'No Option'
    }
    setflavourname(flavourname)
    setflavourid(flavourid)
  }

  const optionChange = (e) => {
    let option_id = e.target.getAttribute('data-option-id')
    let option_item_id = e.target.getAttribute('data-option-item-id')
    let checked = e.target.checked

    var flavours = stateflavours
    flavours.map((flavour, index) => {
      if (option_id === flavour.id) {
        var flavour_items = flavour.flavouritems
        flavour_items.map((flavour_item, item_index) => {
          if (flavour.multi_select === 0) {
            flavour_item.selected = 0
          }
          if (flavour_item.id === option_item_id) {
            flavour_item.selected = checked === true ? 1 : 0
          }
        })
      }
    })
    setstateflavours([...flavours])
    totalcalculate(flavours)
  }

  //check cart response
  const [cartresponse, setcartresponse] = useState(0)
  const addtocart = async () => {
    setcartresponse(3)
    const data = {
      apiToken: jsontoken.api_token,
      quantity: qty,
      price: sizeprice,
      total: totals,
      meal_id: currentmealid,
      size: sizename,
      flavour: flavourname,
      flavourid: flavourid,
      options: stateflavours,
      restaurant_id: restaurant.restaurantid,
      client_id: jsontoken.user_id,
    }
    var resp
    try {
      resp = await Axios.post(`${K.baseUrl}addtocart`, data)
    } catch (error) {
      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.message &&
        error.response.data.message.indexOf('log in') > -1
      ) {
        props.logOut()
        return
      }
    }
    if (resp && resp.message && resp.message.indexOf('log in') > -1) {
      props.logOut()
      return
    }
    if (
      resp.data.resultcode === 0 &&
      resp.data.message === 'Invalid access token please log in'
    ) {
      props.logOut()
    } else if (resp.data.resultcode === 1) {
      setcartresponse(1)
      handleClose()
    } else {
      setcartresponse(2)
    }
    // fetchcart();
  }
  //fetch cart

  const handleProductCardClicked = async () => {
    handleClickOpen('paper', mealObj)

    totalcalculate()
    alertlogin()
    setcartresponse(0)

    setcurrentmealid(restaurant.restaurantid)

    setsizes([])
    setstateflavours([])
    setsizes(mealObj.sizes)
    setstateflavours(mealObj.flavours)

    var dateObj = new Date()
    var weekdayNumber = dateObj.getDay()
  }
  return (
    <Card sx={{ display: 'flex' }} className="cardScroll ml-2">
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <CardContent sx={{ flex: '1 0 auto' }}>
          <Typography component="div" variant="h5">
            {mealObj.meal}
          </Typography>
          <Typography
            variant="subtitle1"
            color="text.secondary"
            component="div"
          >
            <Chip label={mealObj.category} variant="outlined" />
          </Typography>
        </CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', pl: 1, pb: 1 }}>
          <IconButton
            aria-label="previous"
            onClick={handleClickOpen('paper', mealObj)}
          >
            <OpenInNewIcon />
          </IconButton>
          <Typography aria-label="">JMD $ {mealObj.sizes[0].price}</Typography>
        </Box>
      </Box>
      <CardMedia
        component="img"
        sx={{ maxWidth: 151, maxHeight: 190 }}
        image={`${K.imageBaseUlr}/images_fd/${mealObj.image}`}
        alt={mealObj.meal}
        onClick={handleClickOpen('paper', mealObj)}
      />
      <Dialog
        open={open}
        onClose={handleClose}
        scroll={scroll}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title">
          {currentClickedMeal.meal}
        </DialogTitle>
        <DialogContent dividers={scroll === 'paper'}>
          <CardMedia
            component="img"
            sx={{ height: 150, width: 500 }}
            image={`${K.imageBaseUlr}/images_fd/${currentClickedMeal.image}`}
            alt={mealObj.meal}
            className="responsive rounded"
          />
          <CardContent>
            <div className="size mb-2">
              {sizes.length > 0 ? <h4>Select the Size</h4> : ''}
              <select onChange={sizechange} className="mt-2">
                {sizes.length > 0 ? (
                  <>
                    {sizes.map((statesize, index) => (
                      <option key={index} value={statesize['price']}>
                        {statesize.size}
                      </option>
                    ))}
                  </>
                ) : (
                  <option value="0">No size</option>
                )}
              </select>
            </div>
            {stateflavours && stateflavours.length > 0 && (
              <div className="flavour mt-2">
                <h4>Select the option</h4>
                {stateflavours.map((stateflavour, index) => (
                  <div
                    data-option-id={stateflavour.id}
                    className="div_option_panel"
                    key={index}
                  >
                    <div className="mb-2">
                      <b>{stateflavour.flavour}</b>
                      <span className="ml-3">
                        (
                        {stateflavour.multi_select === '1'
                          ? 'Optional'
                          : 'Required-Choose 1'}
                        )
                      </span>
                    </div>
                    <div className="row m-0">
                      {stateflavour.flavouritems.map(
                        (flavour_item, item_index) => (
                          <div
                            className="col-sm-4 m-0 pl-2 pr-0"
                            key={'flavour-item' + item_index}
                          >
                            {stateflavour.multi_select === '1' ? (
                              <input
                                type="checkbox"
                                id={'option_item_' + flavour_item.id}
                                onChange={optionChange}
                                data-option-id={stateflavour.id}
                                data-option-item-id={flavour_item.id}
                              />
                            ) : (
                              <input
                                type="radio"
                                id={'option_item_' + flavour_item.id}
                                name={'option_' + stateflavour.id}
                                onChange={optionChange}
                                data-option-id={stateflavour.id}
                                data-option-item-id={flavour_item.id}
                                checked={
                                  flavour_item.selected === 1 ? 'checked' : ''
                                }
                              />
                            )}
                            <label
                              htmlFor={'option_item_' + flavour_item.id}
                              className="mb-0"
                            >
                              <span>{flavour_item.name}</span>
                              {flavour_item.add_price !== '0' ? (
                                <span className="ml-2">
                                  {'+$' + flavour_item.add_price}
                                </span>
                              ) : (
                                ''
                              )}
                            </label>
                          </div>
                        ),
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
            <div className="quantity mt-2">
              <h4>Choose Quantity</h4>
              <div className="quantity-btn">
                <button id="minus" onClick={subqty} className="btn btn-success">
                  -
                </button>
                <span id="number" className="m-2">
                  {qty}
                </span>
                <button id="plus" onClick={addqty} className="btn btn-success">
                  +
                </button>
              </div>
            </div>

            <div className="total">
              <span>Totals: JMD ${totals}</span>
            </div>
            {cartresponse === 3 ? (
              <span>
                <p className="text-spinner-font">
                  <i className="fa fa-spinner fa-spin spinner-font"></i>
                  &nbsp;Please Wait...
                </p>
              </span>
            ) : cartresponse === 1 ? (
              <div className="alert alert-success">Added to Cart</div>
            ) : cartresponse === 2 ? (
              <div className="alert alert-danger">
                You can only order from one restaurant at a time.
              </div>
            ) : (
              ''
            )}
          </CardContent>
        </DialogContent>
        <DialogActions>
          <Button variant="secondary" onClick={handleClose}>
            Back
          </Button>
          {totals === 0 || restaurant.opened === 0 ? (
            <span className="text-danger">
              {' '}
              The Restaurant Not Opened Yet!{' '}
            </span>
          ) : restaurant.restaurant.open_status === 'close' ? (
            <span className="text-danger"> Unavailable for orders! </span>
          ) : (
            <Button variant="primary" onClick={addtocart}>
              Add to Cart
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </Card>
  )
}
export default ProductCard
